<template>
  <div>
    <div
      :class="`bg-${getColorMode.background} text-${getColorMode.text} border-${getColorMode.globalBackground} shadow-table border-radius-20 p-3 position-relative`"
    >
      <Loading v-if="loading" />
      <div class="row">
        <div class="col">
          <div class="form-floating text-dark my-3">
            <input
              v-model="form.name"
              type="text"
              class="form-control border-secondary"
              id="formName"
              maxlength="55"
            /><span class="character-counter" v-if="form.name"
              >{{ form.name.length }} / 55</span
            >
            <label for="formName">Nombre</label>
            <p class="missing-data-message" v-if="validateData()">
              {{ validateDataMessage("name") }}
            </p>
          </div>
          <div class="form-floating text-dark my-3">
            <input
              v-model="form.rut"
              type="text"
              class="form-control border-secondary"
              id="formName"
              @keyup="formatRut"
              maxlength="10"
            />
            <label for="formName">Rut</label>
            <p class="missing-data-message" v-if="validateData()">
              {{ validateDataMessage("rut") }}
            </p>
          </div>
          <div class="form-floating text-dark my-3">
            <textarea
              v-model="form.description"
              class="form-control border-secondary text-area-padding"
              placeholder="Leave a comment here"
              id="formDescription"
              style="height: 100px"
              maxlength="255"
            ></textarea
            ><span class="character-counter" v-if="form.description"
              >{{ form.description.length }} / 255</span
            >
            <label class="label-form-description" for="formDescription"
              >Descripción</label
            >
            <p class="missing-data-message" v-if="validateData()">
              {{ validateDataMessage("description") }}
            </p>
          </div>
          <div class="d-flex justify-content-end">
            <button
              type="button"
              @click="saveData()"
              class="btn btn-primary"
              :disabled="validateData()"
            >
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Loading from "@/components/Loading.vue";
export default {
  name: "company-form",
  emits: ["setBreadcrumb"],
  components: { Loading },
  props: {
    dataId: { default: null },
  },
  data() {
    return {
      breadcrumb: [{ text: "Empresas", link: { name: "companies" } }],
      form: { name: null, rut: null, description: null },
      loading: false,
    };
  },
  created() {
    this.setData();
    if (this.dataId) {
      this.breadcrumb.push({
        text: "Editar",
        link: { name: "edit-company-form" },
      });
    } else {
      this.breadcrumb.push({
        text: "Crear",
        link: { name: "new-company-form" },
      });
    }
    this.$emit("setBreadcrumb", this.breadcrumb);
  },
  methods: {
    setData() {
      let app = this;
      if (this.dataId) {
        this.axios
          .get(`companies/${this.dataId}`)
          .then((result) => {
            app.form = result.data.body;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    saveData() {
      let app = this;
      this.loading = true;
      if (this.dataId) {
        this.axios
          .put(`companies/${this.dataId}`, { company: this.form })
          .then(() => {
            app.loading = false;
            app.$router
              .push({
                name: "companies",
                params: { alertMsg: "Guardado correcto!" },
              })
              .catch();
          })
          .catch((error) => {
            app.loading = false;
            console.log(error);
          });
      } else {
        this.axios
          .post("companies", { company: this.form })
          .then(() => {
            app.loading = false;
            app.$router
              .push({
                name: "companies",
                params: { alertMsg: "Guardado correcto!" },
              })
              .catch();
          })
          .catch((error) => {
            app.loading = false;
            console.log(error);
          });
      }
    },
    validateData() {
      if (this.form.name && this.form.rut && this.form.description)
        return false;
      return true;
    },
    validateDataMessage(field) {
      switch (field) {
        case "name":
          if (!this.form.name) return "Debe ingresar un nombre";
          break;
        case "rut":
          if (!this.form.rut) return "Debe ingresar un rut";
          break;
        case "description":
          if (!this.form.description) return "Debe ingresar una descripción";
          break;
      }
    },
    digit(rut, dv) {
      let sumResult = 0;
      let multiplier = 2;
      while (rut !== 0) {
        if (multiplier === 8) {
          multiplier = 2;
        }
        sumResult += (rut % 10) * multiplier;
        rut = Math.trunc(rut / 10);
        multiplier++;
      }
      sumResult = 11 - (sumResult % 11);
      switch (sumResult) {
        case 11:
          return "0" === dv;
        case 10:
          return "K" === dv.toUpperCase();
        default:
          return sumResult.toString() === dv;
      }
    },
    formatRut() {
      if (this.form.rut.length > 0) {
        this.form.rut = this.form.rut.replace(/[^\dKk]/g, "");
        let data = this.form.rut;
        let length = data.length;
        if (length === 1) {
          this.dv = data;
          this.form.rut = "";
          this.digit(this.form.rut, this.dv);
          this.format();
        } else if (length > 1) {
          this.dv = data.substring(length - 1);
          this.form.rut = data.substring(length - 1, 0);
          this.digit(this.form.rut, this.dv);
          this.format();
        }
      }
    },
    format() {
      let rut = this.form.rut ? parseInt(this.form.rut) + "-" : "";
      this.form.rut = rut + this.dv;
    },
  },
  computed: {
    ...mapGetters("general", ["getColorMode"]),
    getFolderList() {
      return this.folderList;
    },
    getFolders() {
      return this.folders;
    },
  },
};
</script>
